// import PropTypes from 'prop-types';

export interface Host {
    context: {
        router: any
    }
}

// declare var window: any;

export function go(props: { onBack?: () => void, to?: string }, host: Host) {
    const {onBack, to} = props;
    let history = host.context.router.history;
    if (to) {
        history.push(to);
    } else {
        if (onBack) {
            onBack();
        } else {
            if (history.length == 1) {
                history.push('/');
            } else {
                history.goBack();
            }
        }
    }
}

/**
 * 跳转到指定页面
 * @param path 页面路由路径
 * @param host host
 */
export function push(path: string, host: Host, replace?: boolean) {
    var history = host.context.router.history;
    replace ? history.replace(path) : history.push(path);
}

// var mYurl = location.href.indexOf('http://localhost:3000') >= 0 ? 'http://192.168.1.125:3000/' : 'http://www.dappstore.one/'; //http://www.51dapp.net/#!/   http://192.168.1.125:3000/#!/
/* 与app交互 发送 */
/**
 *
 * @param name
 *  url
 * @param type
 *  类型1：返回+标题+筛选
 *  类型2：关闭+标题+分享
 *  类型3：返回+标题
 *  类型4：文字+搜索
 *
 */
// export function sendMessage(name: string, type: number) {
//     try {
//         window.DApp && window.DApp.skipNewPage(mYurl + name, type);  //所有的跳转界面
//         window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.skipNewPage.postMessage({
//             url: mYurl + name,
//             type: type
//         });
//     } catch (error) {
//         window.myConsole(name);
//     }
// }

/**
 *
 * @param name //游戏地址
 * @param title //游戏名称
 */
// export function sendMessageUrl(name: string, title: string) {
//     window.DApp && window.DApp.playDAppGame(name, title); // 开始游戏
//     window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.playDAppGame.postMessage({
//         url: name,
//         title: title
//     });
// }

/**
 * // 页面刷新
 */
// export function sendMessageLoad() {
//     window.DApp && window.DApp.onClickLoad(); // 页面刷新
//     window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.onClickLoad.postMessage();
// }

/**
 * // 返回搜索内容
 * @param text 文字
 */
// export function sendMessageSearch(text) {
//     window.DApp && window.DApp.onClickSearch(text);
//     window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.onClickSearch.postMessage(text);
// }

/**
 *
 * @param url //跳转地址
 */
// export function sendMessageOfficialUrl(url) {
//     window.DApp && window.DApp.playDAppOfficial(url); // 跳转官网
//     window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.playDAppOfficial.postMessage(url);
// }

/**
 * 获取当前路由参数
 * @param key 参数
 * @param host
 */
export function getParam(key: string, host: Host) {
    let params = host.context.router.route.match.params;
    return params[key];
}

// export function isPath(path: string, host: Host) {
//     var pathname = host.context.router.route.location.pathname;
//     return pathname.indexOf(path) > -1;
// }
//
// type IReactComponent<P = any> =
//     | React.StatelessComponent<P>
//     | React.ComponentClass<P>
//     | React.ClassicComponentClass<P>
//
// export function routeable<T extends IReactComponent>(target: T): T {
//     let obj: any = target;
//     if (!obj['contextTypes']) {
//         obj['contextTypes'] = {};
//     }
//     obj['contextTypes']['router'] = PropTypes.object;
//     return obj;
// }


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/route.ts